import { render, staticRenderFns } from "./TemplateTicketCard.vue?vue&type=template&id=e872a592&scoped=true&"
import script from "./TemplateTicketCard.vue?vue&type=script&lang=js&"
export * from "./TemplateTicketCard.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTicketCard.vue?vue&type=style&index=0&id=e872a592&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e872a592",
  null
  
)

export default component.exports